<template >
  <div
      v-display-history-v2="{values: inputObj.val, options: inputObj.templates.options, $t: $t, limit: inputObj.templates.display.limit}"
  ></div>

  <display-debug>
    <template #debugView>inputObj.val {{inputObj.val}}</template>
  </display-debug>
</template>

<script>
import multiselect  from 'vue-multiselect'
export default {
  name: "HistoryInput3",
  components: {
    multiselect,
  },
  props: {
    "inputObj": Object,
    "formObj": Object,
    "modelValue": [Object, String, Number],
    "activeLang": {
      type: [String],
      required: false,
      default: null,
    },
  },
  data() {
    return {
      inputModel: {},
      selectModel: null,
      options:[],
      optionsArr:[],
    }
  },
  mounted() {

  },
  methods: {

  },

  watch: {
    inputModel: {
      handler(newVal) {
        //this.$emit('update:modelValue', JSON.stringify(newVal))
        this.$emit('update:modelValue', newVal)
      },
      deep: true,
      immediate: true
    },
  },
};
</script>
